export enum TrackEventTypes {
  SOCIAL_SHARING_START_PROGRESS = 'social_sharing_start_progress',
  SOCIAL_SHARING_FACEBOOK_CLICK = 'social_sharing_facebook_click',
  SOCIAL_SHARING_TWITTER_CLICK = 'social_sharing_twitter_click',
  SOCIAL_SHARING_LINKEDIN_CLICK = 'social_sharing_linkedin_click',
  SOCIAL_SHARING_LINK_CLICK = 'social_sharing_link_click',
  SOCIAL_SHARING_WHATSAPP_CLICK = 'social_sharing_whatsapp_click',
}

export enum SocialSharingType {
  URL = 'url',
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
  WHATSAPP = 'whatsapp',
}

export const eventsToEmit: { [key in SocialSharingType]: TrackEventTypes } = {
  [SocialSharingType.FACEBOOK]: TrackEventTypes.SOCIAL_SHARING_FACEBOOK_CLICK,
  [SocialSharingType.TWITTER]: TrackEventTypes.SOCIAL_SHARING_TWITTER_CLICK,
  [SocialSharingType.LINKEDIN]: TrackEventTypes.SOCIAL_SHARING_LINKEDIN_CLICK,
  [SocialSharingType.URL]: TrackEventTypes.SOCIAL_SHARING_LINK_CLICK,
  [SocialSharingType.WHATSAPP]: TrackEventTypes.SOCIAL_SHARING_WHATSAPP_CLICK,
};
